import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=460e46e5&scoped=true&"
import script from "./HeaderBar.vue?vue&type=script&lang=js&"
export * from "./HeaderBar.vue?vue&type=script&lang=js&"
import style0 from "@/sass/08_modules/header-bar.scss?vue&type=style&index=0&id=460e46e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460e46e5",
  null
  
)

export default component.exports